export default __webpack_public_path__ + "static/media/close.be7dda1d.svg";